module.exports = __webpack_public_path__ + "static/media/login-left.95613570.jpg";